// extracted by mini-css-extract-plugin
export default {"dateAndTime":"DateAndTime_dateAndTime__lBcdc","icon":"DateAndTime_icon__FqWj4","text":"DateAndTime_text__krGJ5"};